import React, { useEffect, useState } from 'react';
import styles from './contactUs.module.scss'
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Button, axios, logError, ErrorLogModel } from 'react-mimg'

export default function EmployeeTaxInformation(props) {
    


    return (
        <Modal isOpen={props.isOpen} size='xl' toggle={props.toggle} >
            <ModalHeader toggle={props.toggle}>
                <strong>IMPORTANT HEALTH COVERAGE TAX DOCUMENTS</strong>
            </ModalHeader>
            <ModalBody>
                <p>The 2024 Form 1095-Cs are prepared and available upon request.
                    Form 1095-Cs provide information about offers of coverage made to full-time employees.</p>
                <p>To request a copy of your Form 1095 or for further information, contact:</p>
                <div>
                    <strong>Monarch Benefits</strong><br/>
                        <a href="mailto:mimgbenefits@monarchinvestment.com">mimgbenefits@monarchinvestment.com</a><br/>
                            2195 N Hwy 83<br/>
                            Franktown, CO 80116<br/>
                            Phone: <a href="tel:8337222488">833-722-2488</a>
                </div>
            </ModalBody>
        </Modal>
            
    )
}